// src/services/einvoice.js
export const addEInvoice = async (data) => {
  const response = await fetch(process.env.REACT_APP_API_URL, {
    method: "POST",
    body: JSON.stringify({
      action: "addEInvoice",
      apiKey: process.env.REACT_APP_API_KEY,
      origin: window.location.origin,
      ...data,
    }),
  });
  const jsonResponse = await response.json();
  if (jsonResponse?.success === true) {
    const data_res = { ...data, id: jsonResponse?.data?.id };
    jsonResponse.data = data_res;
  }
  console.log("Add E-Invoice Response:", jsonResponse);
  return jsonResponse;
};

export const updateEInvoice = async (invoiceId, invoiceData) => {
  const response = await fetch(process.env.REACT_APP_API_URL, {
    method: "POST",
    body: JSON.stringify({
      action: "updateEInvoice",
      apiKey: process.env.REACT_APP_API_KEY,
      origin: window.location.origin,
      id: invoiceId,
      ...invoiceData,
    }),
  });
  const jsonResponse = await response.json();
  if (jsonResponse?.success === true) {
    const data_res = { ...invoiceData, id: invoiceId };
    jsonResponse.data = data_res;
  }
  console.log("Update E-Invoice Response:", jsonResponse);
  return jsonResponse;
};

export const deleteEInvoice = async (invoiceId) => {
  const response = await fetch(process.env.REACT_APP_API_URL, {
    method: "POST",
    body: JSON.stringify({
      action: "deleteEInvoice",
      apiKey: process.env.REACT_APP_API_KEY,
      origin: window.location.origin,
      id: invoiceId,
    }),
  });
  return await response.json();
};